import React, { useEffect } from 'react';
import { Box, Popover, Text } from '@wix/design-system';
import { StatusAlert } from 'wix-ui-icons-common';
import styles from './MonthlyPopoverWarning.module.scss';
import { PaymentCycle } from 'enums';
import { Trans } from 'react-i18next';

export const MonthlyPopoverWarning = (props: {
  children: React.ReactNode;
  currentCycle: PaymentCycle;
  isInSale: boolean;
}) => {
  const [shown, setShown] = React.useState(false);

  const warningKey = props.isInSale
    ? 'premium-purchase-plan.package_picker_and_cycle_selector.monthly_sale_tooltip'
    : 'premium-purchase-plan.package_picker_and_cycle_selector.monthly_tooltip';

  const open = () => {
    setShown(true);
  };

  const close = () => {
    setShown(false);
  };

  const children = props.children;

  useEffect(() => {
    if (props.currentCycle === PaymentCycle.MONTHLY) {
      open();
    } else {
      close();
    }
  }, [props.currentCycle]);

  return (
    <Box align='center' verticalAlign='middle'>
      <Popover
        showArrow
        animate
        placement='right'
        shown={shown}
        hideDelay={150}
      >
        <Popover.Element>{children}</Popover.Element>
        <Popover.Content>
          <Box padding='12px 24px' width={248}>
            <StatusAlert className={styles.monthlyPopoverStatusAlert} />
            <Text
              size='small'
              skin='standard'
              weight='thin'
              style={{ marginLeft: 8 }}
            >
              <Trans
                i18nKey={warningKey}
                values={{
                  strong: <strong />,
                }}
              />
            </Text>
          </Box>
        </Popover.Content>
      </Popover>
    </Box>
  );
};
